import styled, { css } from 'styled-components';
import { FormMessage } from '../form-message/index.js';
import {} from './index.js';
import { getMargins, SYS_SIZE_FIXED_1400, SYS_SIZE_FIXED_600, SYS_SIZE_FIXED_800, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_50, SEM_TYPOGRAPHY_FORMS_LABEL, getTypographyStyles, SYS_BORDER_RADIUS_MAX, SYS_SPACE_FIXED_800, SYS_BORDER_WIDTH_100, SYS_SPACE_FIXED_100, SYS_SIZE_FIXED_1000 } from '@oneaudi/unified-web-alpha-common';
export const StyledLabel = styled.label `
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  // TODO: token missing
  transition-property: color;
  transition-duration: 250ms;
  transition-timing-function: ease;
  color: ${(props) => props.disabled
    ? props.theme.sem.color.forms.foreground.text.disabled
    : props.theme.sem.color.forms.foreground.text.default};

  ${(props) => !props.disabled &&
    css `
      &:hover {
        color: ${(props) => props.theme.sem.color.forms.foreground.text.interactive};
      }

      &:has(input:focus-visible) {
        color: ${(props) => props.theme.sem.color.forms.foreground.text.interactive};
      }
    `}

  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL)}
  display: flex;
  gap: ${SYS_SPACE_FIXED_150};
  align-items: center;
  ${(props) => props.labelPosition === 'leading' &&
    css `
      justify-content: space-between;
    `}
`;
export const StyledContainer = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  display: inline-flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_100};
`;
export const StyledPill = styled.div `
  overflow: hidden;
  position: relative;

  flex-shrink: 0;
  border-radius: ${SYS_BORDER_RADIUS_MAX};
  height: ${SYS_SIZE_FIXED_800};
  width: ${SYS_SIZE_FIXED_1400};
  // TODO: token missing
  transition-property: background-color, box-shadow;
  transition-duration: 250ms;
  transition-timing-function: ease;

  &::before {
    display: block;
    position: absolute;
    content: '';
    top: 50%;
    // TODO: token missing;
    transition-duration: 250ms;
    transition-timing-function: ease;
    transform: translate(0, -50%);
    transition-property: transform, right, border-color, background-color;
    z-index: 1;
    width: ${SYS_SIZE_FIXED_600};
    height: ${SYS_SIZE_FIXED_600};
    border-radius: ${SYS_BORDER_RADIUS_MAX};
    left: ${SYS_SPACE_FIXED_50};
  }
`;
export const StyledCheckedIcon = styled.svg `
  // TODO: token missing;
  transition: opacity 250ms ease;
  color: ${(props) => props.theme.cmp.color.forms.toggle.active.foreground.icon.default};
  opacity: 0;
`;
export const StyledUncheckedIcon = styled.svg `
  // TODO: token missing;
  transition: opacity 250ms ease;
  color: ${(props) => props.theme.cmp.color.forms.toggle.inactive.foreground.icon.default};
  opacity: 0.7;
`;
export const StyledIconContainer = styled.div `
  display: flex;
  width: ${SYS_SIZE_FIXED_1000};
  justify-content: space-between;
  align-items: center;
  position: absolute;
  left: 4px;
  top: 4px;
  margin: ${SYS_SPACE_FIXED_50};
`;
export const StyledFormMessage = styled(FormMessage) `
  padding-left: ${(props) => props.labelPosition === 'trailing' ? SYS_SPACE_FIXED_800 : 0};

  ${(props) => props.labelPosition === 'leading' &&
    css `
      padding-right: ${SYS_SPACE_FIXED_800};
    `}
`;
export const StyledInput = styled.input `
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  white-space: nowrap;
  width: 1px;
  position: absolute;
  opacity: 0;
  pointer-events: none;

  & + ${StyledPill}  {
    ${(props) => css `
      box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.forms.toggle.inactive.surface.stroke.default};
      background-color: ${props.theme.cmp.color.forms.toggle.inactive.surface
    .fill.default};

      &::before {
        background-color: ${props.theme.cmp.color.forms.toggle.inactive
    .foreground.handle.fill.default};
      }
    `}
  }

  &:checked + ${StyledPill} {
    ${(props) => css `
      box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.forms.toggle.active.surface.stroke.default};
      background-color: ${props.theme.cmp.color.forms.toggle.active.surface.fill
    .default};
    `}

    &::before {
      transform: translate(100%, -50%);
      background-color: ${(props) => props.theme.cmp.color.forms.toggle.active.foreground.handle.fill
    .default};
    }

    ${StyledCheckedIcon} {
      opacity: 0.9;
    }

    ${StyledUncheckedIcon} {
      opacity: 0;
    }
  }

  &:focus-visible + ${StyledPill} {
    outline: 2px solid Highlight;
    outline: 2px solid -webkit-focus-ring-color;
    outline-style: auto;
  }

  &:focus-visible:not(:checked) + ${StyledPill} {
    ${(props) => css `
      box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.forms.toggle.inactive.surface.stroke.default};
      background-color: ${props.theme.cmp.color.forms.toggle.inactive.surface
    .fill.default};

      &::before {
        background-color: ${props.theme.cmp.color.forms.toggle.inactive
    .foreground.handle.fill.default};
      }
    `}
  }

  &:focus-visible:checked + ${StyledPill} {
    ${(props) => css `
      box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.forms.toggle.active.surface.stroke.default};
      background-color: ${props.theme.cmp.color.forms.toggle.active.surface.fill
    .default};

      &::before {
        background-color: ${props.theme.cmp.color.forms.toggle.active.foreground
    .handle.fill.default};
      }
    `}
  }

  &:not(:disabled):not(:checked) + ${StyledPill}:hover {
    ${(props) => css `
      box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.forms.toggle.inactive.surface.stroke
    .interactive};
      background-color: ${props.theme.cmp.color.forms.toggle.inactive.surface
    .fill.interactive};

      &::before {
        background-color: ${props.theme.cmp.color.forms.toggle.inactive
    .foreground.handle.fill.interactive};
      }
    `}

    ${StyledUncheckedIcon} {
      color: ${(props) => props.theme.cmp.color.forms.toggle.inactive.foreground.icon
    .interactive};
    }
  }

  &:not(:disabled):checked + ${StyledPill}:hover {
    ${(props) => css `
      box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.forms.toggle.active.surface.stroke.interactive};
      background-color: ${props.theme.cmp.color.forms.toggle.active.surface.fill
    .interactive};

      &::before {
        background-color: ${props.theme.cmp.color.forms.toggle.active.foreground
    .handle.fill.interactive};
      }
    `}

    ${StyledCheckedIcon} {
      color: ${(props) => props.theme.cmp.color.forms.toggle.active.foreground.icon.interactive};
    }
  }

  &:disabled + ${StyledPill} {
    ${(props) => css `
      background-color: ${props.theme.cmp.color.forms.toggle.inactive.surface
    .fill.disabled};
      box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.forms.toggle.inactive.surface.stroke.disabled};

      &::before {
        background-color: ${props.theme.cmp.color.forms.toggle.inactive
    .foreground.handle.fill.disabled};
      }
    `}

    ${StyledCheckedIcon}, ${StyledUncheckedIcon} {
      opacity: 0;
    }
  }

  &:disabled:checked + ${StyledPill} {
    ${(props) => css `
      background-color: ${props.theme.cmp.color.forms.toggle.active.surface.fill
    .disabled};
      box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.forms.toggle.active.surface.stroke.disabled};

      &::before {
        background-color: ${props.theme.cmp.color.forms.toggle.active.foreground
    .handle.fill.disabled};
      }
    `}
  }
`;
//# sourceMappingURL=index.styles.js.map